import { TechZonesConfig } from '../../../../../models/assets-data/TechZonesConfig.interface';
/**
 * Backup constant for Tech Zones configuration.
 * 
 * This constant represents the default tech zones and their associated teams.
 * It serves as a fallback or backup configuration for the `tech-zones-config.json` file.
 * Each zone is mapped to a name (like "Norfolk" or "Portland"), and each team is assigned to a specific zone.
 * This ensures that, even without a custom configuration, the system can operate with predefined zones and teams.
 */
export const DEFAULT_ASSETS_TECH_ZONES: TechZonesConfig = {
    techZones: {
    zones: {
      "norfolk": "Norfolk",
      "portland": "Portland",
      "z1": "SODO",
      "z2": "Kent",
      "z3": "Redmond",
      "z4": "Everett",
      "z5": "Tacoma",
      "z6": "E WA",
      "z11": "W PDX",
      "z12": "E PDX",
      "z13": "SW PDX",
      "z14": "Eugene"
    },
    techTeams: {
      "blr-seattle": "z1",
      "bpg": "",
      "chr-seattle": "z1",
      "chr-tacoma": "z5",
      "commissioning": "",
      "cnt-inw": "z6",
      "cnt-portland": "z13",
      "cnt-projects": "",
      "cnt-seattle": "norfolk",
      "controls": "",
      "elec-portland": "",
      "elec-seattle": "",
      "elec-service": "",
      "hva-sw-wa": "z13",
      "hvac-e-portland": "z12",
      "hvac-eastern-wa": "z6",
      "hvac-eastside": "z3",
      "hvac-eugene": "z14",
      "hvac-n-sound": "z4",
      "hvac-portland": "portland",
      "hvac-s-king": "z2",
      "hvac-s-sound": "z5",
      "hvac-seattle": "z1",
      "internal": "",
      "oregon-special": "",
      "plb-inw": "",
      "plb-portland": "",
      "plb-seattle": "norfolk",
      "sbs": "",
      "spti": "",
      "svc-logistics": "",
      "tab": ""
    }
  }
};